import ClearIcon from "@mui/icons-material/Clear";
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  OutlinedInputProps,
  Tooltip
} from "@mui/material";
import React, { DispatchWithoutAction } from "react";

interface ClearableTextFieldProps extends OutlinedInputProps {
  onClear: DispatchWithoutAction;
}

const ClearableTextField: React.FC<ClearableTextFieldProps> = ({ label, onClear, ...rest }) => {
  return (
    <FormControl size="small" variant="outlined">
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        size="small"
        endAdornment={
          <InputAdornment position="end">
            <Tooltip title="Clear" arrow>
              <IconButton onClick={onClear} edge="end" size="small">
                <ClearIcon />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        }
        label={label}
        {...rest}
      />
    </FormControl>
  );
};

export default ClearableTextField;
